import React, {useState} from 'react'
import './style.scss'
import Card from '../card'
import bem from '../../helpers/bem'
import {getCardKey} from '../../helpers/card'

const CardContainer = ({
                         cards,
                         addCardToBoard,
                         updateActiveField,
                         updateActiveFieldDelay,
                         setCardsMenu,
                         isMobile,
                       }) => {
  const block = 'container__card';
  const [disableCards, setDisableCards] = useState(false);

  return (
    <div className={block}>
      {cards.map((card, index) => isMobile ? (
        <div
          className={bem({block, elem: 'item'})}
          key={getCardKey(index, card)}
        >
          <Card
            key={getCardKey(index, card)}
            rank={card.rank}
            suit={card.suit}
            active={card.active}
            addCardToBoard={addCardToBoard}
            updateActiveField={updateActiveField}
            updateActiveFieldDelay={updateActiveFieldDelay}
            setCardsMenu={setCardsMenu}
            disable={disableCards}
            setDisableCards={setDisableCards}
            menu
          />
        </div>
      ) : (
        <Card
          key={getCardKey(index, card)}
          rank={card.rank}
          suit={card.suit}
          active={card.active}
          addCardToBoard={addCardToBoard}
          updateActiveField={updateActiveField}
          setCardsMenu={setCardsMenu}
          menu
        />
      ))}
    </div>
  )
};

export default CardContainer;